export default {
	"message": {
		"temperturePerson": "SMS แจ้งเตือนอุณหภูมิผิดปกติ",
		"transferPerson": "ผู้ยืนยันคำสั่งจัดส่งสินค้า",
		"dispatcher": "ผู้ส่งคำสั่งจัดส่งสินค้า",
		"specifyPerson": "ผู้แจ้งที่กำหนดไว้",
		"limitationPerson": "SMS แจ้งเตือนเวลาผิดปกติ",
		"mailPerson": "ตั้งการส่ง CC เมล์",
		"scheduPerson": "ตั้งการส่ง SMS"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/message/message.js